import { render, staticRenderFns } from "./JNavigationDrawer.vue?vue&type=template&id=63c8bae1&scoped=true&"
import script from "./JNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./JNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./JNavigationDrawer.vue?vue&type=style&index=0&id=63c8bae1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8bae1",
  null
  
)

export default component.exports